import {createApp} from 'vue'
import ProfilePicture from './ProfilePicture'

const el = '.kb-component--profile-picture'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ProfilePictureDOM)=>{
            const props = {
                userId: ProfilePictureDOM.dataset.userId ?? "",
                content: ProfilePictureDOM.dataset.content ? JSON.parse(ProfilePictureDOM.dataset.content) : null,
                type: ProfilePictureDOM.dataset.type ?? "cancerforum"
            }
            const component = createApp(ProfilePicture, props).use(Store)
            component.mount(ProfilePictureDOM)
        })
    }
}